<div class="modal-header">
  <h4 class="modal-title" id="exampleModalLabel">
    {{ title | translate }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onClickCloseModal()"
  ></button>
</div>
<div class="modal-body">
  <h5>
    <p style="font-size: 14px">
      {{ "pop-ups_Message.confirmationModal.prompt" | translate }}
      {{ actionLabel | translate }}
      {{ "pop-ups_Message.confirmationModal.article" | translate }}
      {{ targetType | translate }}:
      <b>{{ targetName }}</b>
    </p>
  </h5>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" (click)="onClickCloseModal()">
    {{ "buttons.close" | translate }}
  </button>
  <button
    class="btn btn-primary"
    (click)="onClickConfirmAction()"
    [disabled]="loading"
  >
    <loading-button
      [loading]="loading"
      [value]="'buttons.confirm'"
      [icon]="null"
    ></loading-button>
  </button>
</div>
